import { __assign, __extends } from "tslib";
import cn from 'classnames';
import at from 'lodash-es/at';
import isEqual from 'lodash-es/isEqual';
import * as React from 'react';
import { connect } from 'react-redux';
import { DOMAIN_TYPE_CLIENT_NOTIFICATION, NOTIFICATION_ID__THREAD_IS_TYPING, } from '../../../../consts';
import { config } from '../../../_core/config';
import { createDebugLogger } from '../../../_core/utils/app-utils';
import { domainAction, domainSelector } from '../../../domain/domain-redux';
import { User } from '../../../user/User';
import './TypingUsers.scss';
var _ANY_USER_ID_ = '__any__'; // implementation hack
// "since" delta to consider is_typing notification as relevant
var TTL_THRESHOLD = 10000;
// cleanup interval
var INTERVAL = 1000;
var _doCleanup = function (map) {
    var now = Date.now();
    for (var k in map) {
        if (map.hasOwnProperty(k) && now - map[k] > TTL_THRESHOLD) {
            delete map[k];
        }
    }
    return __assign({}, map);
};
var TypingUsersClass = /** @class */ (function (_super) {
    __extends(TypingUsersClass, _super);
    function TypingUsersClass() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.debug = createDebugLogger('TypingUsers');
        _this.$el = React.createRef();
        _this.state = {
            recentlyTypedUsers: _doCleanup(_this.props.typingUsers),
        };
        _this._periodicalCleanup = function () {
            _this._timerId = setTimeout(function () {
                _this._timerId = null;
                _this.setState({ recentlyTypedUsers: _doCleanup(_this.props.typingUsers) });
                _this._periodicalCleanup();
            }, INTERVAL);
        };
        return _this;
    }
    TypingUsersClass.prototype.componentDidMount = function () {
        this._periodicalCleanup();
    };
    TypingUsersClass.prototype.componentWillUnmount = function () {
        if (this._timerId) {
            clearTimeout(this._timerId);
        }
    };
    TypingUsersClass.prototype.componentDidUpdate = function (prevProps, prevState) {
        // zmena threadu je povazovana za vyssiu autoritu ako pending is typing...
        if (this.props.threadLastUpdated > prevProps.threadLastUpdated) {
            this.setState({ recentlyTypedUsers: {} });
        }
        //
        else if (!isEqual(this.props.typingUsers, this.state.recentlyTypedUsers)) {
            this.setState({ recentlyTypedUsers: this.props.typingUsers });
        }
        // domain cleanup, so TypingUsers will not show up on page refresh
        var currentCount = Object.keys(this.state.recentlyTypedUsers).length;
        var prevCount = Object.keys(prevState.recentlyTypedUsers).length;
        if (prevCount && !currentCount) {
            this.props.dispatch(domainAction.deleteModelByEntityTypeAndId(DOMAIN_TYPE_CLIENT_NOTIFICATION, NOTIFICATION_ID__THREAD_IS_TYPING));
        }
        //
        this._maybeScrollToBottom(prevState);
    };
    TypingUsersClass.prototype._maybeScrollToBottom = function (prevState) {
        var currentCount = Object.keys(this.state.recentlyTypedUsers).length;
        var prevCount = Object.keys(prevState.recentlyTypedUsers).length;
        var $parent = this.props.parentContainer.current;
        var $el = this.$el.current;
        // workaround - make sure that chat indicator is scrolled down without setting recentlyTypedUsers
        if (this.props.isAgentTyping) {
            currentCount = 1;
        }
        // scrollovat dole pri isTyping chceme pomerne defenzivne, teda:
        // iba ak sa objavujeme nanovo...
        if (currentCount && !prevCount && $parent && $el) {
            var elBox = $el.getBoundingClientRect();
            var parentBox = $parent.getBoundingClientRect();
            // a sucasne: iba ak je element ciastocne viditelny, tak ho scrollneme dole
            // inak sme noop
            // poznamka: nizsie je viac pokus/omyl ako teoreticka uvaha...
            // prettier-ignore
            var shouldScroll = ($parent.scrollHeight - $parent.scrollTop - parentBox.height - elBox.height)
                <= elBox.height;
            if (shouldScroll) {
                this.props.scrollToBottom && this.props.scrollToBottom();
            }
        }
    };
    TypingUsersClass.prototype.render = function () {
        if (this.props.isAgentTyping) {
            return this._renderIcon();
        }
        var names = Object.keys(this.state.recentlyTypedUsers);
        if (!names.length) {
            return null;
        }
        return this.props.iconOnly ? this._renderIcon(names) : this._renderNames(names);
    };
    TypingUsersClass.prototype._renderIcon = function (names) {
        if (names === void 0) { names = null; }
        var B = config.css.B('-typing-users');
        return (React.createElement("div", { className: cn(B, "".concat(B, "--bounce")), ref: this.$el },
            React.createElement("div", { className: "bounce1" }),
            React.createElement("div", { className: "bounce2" }),
            React.createElement("div", { className: "bounce3" })));
    };
    // todo: to be improved...
    TypingUsersClass.prototype._renderNames = function (names) {
        var B = config.css.B('-typing-users');
        return (React.createElement("div", { className: cn(B, "".concat(B, "--users")), ref: this.$el },
            React.createElement("small", null, names.join(', '))));
    };
    TypingUsersClass.defaultProps = {
        typingUsers: {},
        iconOnly: true,
    };
    return TypingUsersClass;
}(React.Component));
var mapStateToProps = function (state, ownProps) {
    var threadId = ownProps.threadId, threadLastUpdated = ownProps.threadLastUpdated;
    var typingUsers = {};
    // hm... a přitom taková blbost...
    // prettier-ignore
    var n = domainSelector.getClientNotification(state)(NOTIFICATION_ID__THREAD_IS_TYPING);
    if (n) {
        // array of names, ids, or just boolean flag
        var nUserId = at(n, ['payload.user_id'])[0];
        var nThreadId = at(n, ['payload.thread_id'])[0];
        var nCreated = new Date(n.created).valueOf();
        if (
        // ak bolo vobec nieco poslane a notifikacia sa tyka aktualneho vlakna
        nUserId &&
            nThreadId === threadId &&
            // a sucasne notifikacia je novsia ako posledny update vlakna (toto bude
            // zmysluplne fungovat len za predpokladu, ze db casy a client su v syncu...)
            nCreated > threadLastUpdated) {
            // ak sme dostali flag only... tak si podhodime "any" usera...
            if (typeof nUserId === 'boolean') {
                typingUsers[_ANY_USER_ID_] = Date.now();
            }
            else {
                // vzdy normalizujeme na pole ideciek
                nUserId = Array.isArray(nUserId) ? nUserId : [nUserId];
                typingUsers = nUserId.reduce(function (memo, _uid) {
                    if (_uid) {
                        var typingUserData = domainSelector.getUser(state)(_uid);
                        var typingUserName = typingUserData
                            ? new User(typingUserData).name || _uid
                            : _uid;
                        memo[typingUserName] = Date.now();
                    }
                    return memo;
                }, {});
            }
        }
    }
    var uiState = domainSelector.getUIState(state) || {};
    var isAgentTyping = uiState.is_agent_typing;
    return { typingUsers: typingUsers, isAgentTyping: isAgentTyping };
};
var mapDispatchToProps = function (dispatch, ownProps) {
    return ({ dispatch: dispatch });
};
export var TypingUsers = connect(mapStateToProps, mapDispatchToProps)(TypingUsersClass);
// lebo react-loadable s defaultnym exportom vyzaduje menej roboty
export default TypingUsers;
